<template>
	<div class="app-container">
		<el-card class="filter-card">
			<el-form :inline="true" :model="filterForm" class="filter-form">
				<el-form-item label="审批类型">
					<el-select v-model="filterForm.oa_type" placeholder="请选择审批类型" clearable style="width: 100px;">
						<el-option label="报价审批" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="审批状态">
          <el-select v-model="filterForm.status" placeholder="请选择审批状态" clearable style="width: 100px;">
            <el-option label="待审批" :value="1"></el-option>
            <el-option label="已通过" :value="2"></el-option>
            <el-option label="已拒绝" :value="3"></el-option>
          </el-select>
        </el-form-item> -->
				<el-form-item label="审批种类">
					<el-select v-model="filterForm.type" placeholder="请选择审批状态" clearable style="width: 100px;">
						<el-option label="我提交的" value="my"></el-option>
						<el-option label="抄送的" value="copy"></el-option>
						<el-option label="我审批的" value="其他"></el-option>
						<!-- <el-option label="已撤回" value="withdrawn"></el-option> -->
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="时间范围">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="YYYY-MM-DD">
          </el-date-picker>
        </el-form-item> -->
				<el-form-item>
					<el-button type="primary" @click="handleSearch">查询</el-button>
					<el-button @click="resetForm">重置</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<el-card class="table-card">
			<el-table :data="approvalList" style="width: 100%" height="calc(100vh - 320px)" v-loading="loading" stripe
				ref="approvalTable">
				<el-table-column type="index" label="序号" width="60" />
				<el-table-column prop="type" label="审批类型">
					<template #default="scope">
						{{ getTypeText(scope.row.oaType) }}
					</template>
				</el-table-column>
				<el-table-column prop="examineName" label="审批标题"></el-table-column>
				<el-table-column prop="username" label="申请人"></el-table-column>
				<el-table-column prop="createTime" label="申请时间">
					<template #default="scope">
						{{ formatDateTime(scope.row.createTime) }}
					</template>
				</el-table-column>
				<el-table-column prop="status" label="审批状态">
					<template #default="scope">
						<el-tag :type="getStatusType(scope.row.status)">
							{{ getStatusText(scope.row.status) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="currentApprover" label="当前审批人"></el-table-column>
				<el-table-column label="操作" width="100" fixed="right">
					<template #default="scope">
						<el-button size="small" type="warning" @click="handleView(scope.row)">详情</el-button>
						<el-button v-if="scope.row.status === 1 && isApprover(scope.row)" size="small" type="success"
							@click="handleApprove(scope.row)">审批</el-button>
						<!-- <el-button 
              v-if="scope.row.status === 'pending' && isApplicant(scope.row)"
              size="mini" 
              type="danger" 
              @click="handleWithdraw(scope.row)">撤回</el-button> -->
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination-container">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</el-card>

		<!-- 查看审批详情对话框 -->
		<el-dialog class="mydialog" title="审批详情" v-model="viewDialogVisible" width="50vw" :close-on-click-modal="false"
			align-center>
			<el-tabs v-model="activeTab" type="border-card">
				<el-tab-pane label="基本信息" name="basic">
					<div class="contacts-section">
						<el-descriptions :column="2" border>
							<el-descriptions-item
								label="审批类型">{{ getTypeText(viewApproval.oaType) }}</el-descriptions-item>
							<el-descriptions-item label="审批标题">{{ viewApproval.examineName }}</el-descriptions-item>
							<el-descriptions-item label="申请人">{{ viewApproval.username }}</el-descriptions-item>
							<el-descriptions-item
								label="申请时间">{{ formatDateTime(viewApproval.createTime) }}</el-descriptions-item>
							<el-descriptions-item label="审批状态">
								<el-tag :type="getStatusType(viewApproval.status)">
									{{ getStatusText(viewApproval.status) }}
								</el-tag>
							</el-descriptions-item>
							<el-descriptions-item
								label="当前审批人">{{ viewApproval.currentApprover }}</el-descriptions-item>
						</el-descriptions>
					</div>
				</el-tab-pane>

				<el-tab-pane label="审批流程" name="process">
					<div class="contacts-section">
						<el-timeline>
							<el-timeline-item v-for="(activity, index) in viewApproval.process" :key="index"
								:type="getTimelineItemType(activity.status)">
								<div class="timeline-item-content">
									<h4>第{{ index + 1 }}步</h4>
									<p><strong>审批人：</strong>{{ activity.username }}</p>
									<p><strong>审批状态：</strong>
										<el-tag :type="getStatusType1(activity.status)" size="small">
											{{ getStatusText1(activity.status) }}
										</el-tag>
									</p>
									<p v-if="activity.examineOpinion">
										<strong>审批意见：</strong>{{ activity.examineOpinion }}
									</p>
									<p><strong>审批时间：</strong>{{ formatDateTime(activity.updateTime) }}</p>
								</div>
							</el-timeline-item>
						</el-timeline>
					</div>
				</el-tab-pane>

				<el-tab-pane label="报价信息" name="quotation" v-if="viewApproval.oaType === 1">
					<div class="contacts-section">
						<div v-if="viewApproval.quotationInfo">
							<el-descriptions :column="2" border>
								<el-descriptions-item
									label="报价编号">{{ viewApproval.quotationInfo.name }}</el-descriptions-item>
								<el-descriptions-item
									label="客户名称">{{ viewApproval.quotationInfo.customerName }}</el-descriptions-item>
								<el-descriptions-item
									label="报价金额">{{ formatAmount(viewApproval.quotationInfo.offerPrice) }}</el-descriptions-item>
								<el-descriptions-item
									label="成本金额">{{ formatAmount(viewApproval.quotationInfo.cost) }}</el-descriptions-item>
								<el-descriptions-item
									label="利润金额">{{ formatAmount(viewApproval.quotationInfo.profit) }}</el-descriptions-item>
								<el-descriptions-item
									label="有效期至">{{ formatDateTime(viewApproval.quotationInfo.offerTime) }}</el-descriptions-item>
								<el-descriptions-item label="报价状态">
									<el-tag :type="getQuotationStatusType(viewApproval.quotationInfo.status)">
										{{ getQuotationStatusText(viewApproval.quotationInfo.status) }}
									</el-tag>
								</el-descriptions-item>
								<el-descriptions-item
									label="创建时间">{{ formatDateTime(viewApproval.quotationInfo.createTime) }}</el-descriptions-item>
								<el-descriptions-item label="备注说明"
									:span="2">{{ viewApproval.quotationInfo.remark || '无' }}</el-descriptions-item>
							</el-descriptions>

							<h3 style="margin-top: 20px;">报价明细</h3>
							<el-table :data="viewApproval.quotationInfo.businessProducts" border style="width: 100%">
								<el-table-column type="index" label="序号" width="60" />
								<el-table-column prop="productName" label="产品名称"></el-table-column>
								<el-table-column prop="unit" label="单位" width="80"></el-table-column>
								<el-table-column prop="productNum" label="数量" width="100"></el-table-column>
								<el-table-column prop="productPrice" label="单价" width="120">
									<template #default="scope">
										{{ formatAmount(scope.row.productPrice) }}
									</template>
								</el-table-column>
								<el-table-column prop="amount" label="金额" width="120">
									<template #default="scope">
										{{ formatAmount(scope.row.amount) }}
									</template>
								</el-table-column>
							</el-table>
						</div>
						<el-empty v-else description="暂无报价信息"></el-empty>
					</div>
				</el-tab-pane>

				<el-tab-pane label="线索信息" name="lead"
					v-if="viewApproval.quotationInfo && viewApproval.quotationInfo.leadId">
					<div v-if="viewApproval.leadInfo">
						<el-descriptions :column="2" border>
							<el-descriptions-item label="线索名称">{{ viewApproval.leadInfo.name }}</el-descriptions-item>
							<el-descriptions-item
								label="客户名称">{{ viewApproval.leadInfo.customerName }}</el-descriptions-item>
							<el-descriptions-item
								label="联系人">{{ viewApproval.leadInfo.contactName }}</el-descriptions-item>
							<el-descriptions-item
								label="联系电话">{{ viewApproval.leadInfo.contactPhone }}</el-descriptions-item>
							<el-descriptions-item
								label="预计金额">{{ formatAmount(viewApproval.leadInfo.expectedAmount) }}</el-descriptions-item>
							<el-descriptions-item
								label="预计成交时间">{{ formatDateTime(viewApproval.leadInfo.expectedTime) }}</el-descriptions-item>
							<el-descriptions-item label="线索状态">
								<el-tag :type="getLeadStatusType(viewApproval.leadInfo.status)">
									{{ getLeadStatusText(viewApproval.leadInfo.status) }}
								</el-tag>
							</el-descriptions-item>
							<el-descriptions-item
								label="创建时间">{{ formatDateTime(viewApproval.leadInfo.createTime) }}</el-descriptions-item>
							<el-descriptions-item label="备注说明" :span="2">
								<span style="white-space: pre-wrap">{{ viewApproval.leadInfo.remark || '无' }}</span>
							</el-descriptions-item>
						</el-descriptions>
					</div>
					<el-empty v-else description="暂无线索信息"></el-empty>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>

		<!-- 审批操作对话框 -->
		<el-dialog :title="approvalDialogTitle" v-model="approvalDialogVisible" width="500px">
			<el-form :model="approvalForm" :rules="approvalRules" ref="approvalForm" label-width="100px">
				<el-form-item label="审批结果" prop="status">
					<el-radio-group v-model="approvalForm.status">
						<el-radio :label="1">通过</el-radio>
						<el-radio :label="2">拒绝</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="审批意见" prop="examineOpinion">
					<el-input type="textarea" v-model="approvalForm.examineOpinion" :rows="4"
						placeholder="请输入审批意见"></el-input>
				</el-form-item>
				<!-- <el-form-item v-if="isLastApprover" label="抄送人" prop="ccUsers">
          <el-select
            v-model="approvalForm.ccUsers"
            multiple
            filterable
            remote
            :remote-method="searchUsers"
            :loading="userSearchLoading"
            placeholder="请输入用户名搜索"
            style="width: 100%">
            <el-option
              v-for="item in userOptions"
              :key="item.id"
              :label="item.username"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="approvalDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submitApproval">确 定</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getExamineInfo,
		approveApproval,
		withdrawApproval,
		getOfferDetail,
		getExamineFlowDetail
	} from '@/api/approval'
	import {
		getLeadDetail
	} from '@/api/lead'
	import dayjs from 'dayjs'
	import {
		debounce
	} from 'lodash-es'
	import {
		useStore
	} from 'vuex'
	import {
		getUserList
	} from '@/api/auth'

	export default {
		name: 'ApprovalManagement',
		data() {
			return {
				filterForm: {
					oa_type: '',
					status: '',
					type: 'my',
					startDate: '',
					endDate: ''
				},
				dateRange: [],
				approvalList: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				viewDialogVisible: false,
				approvalDialogVisible: false,
				approvalDialogTitle: '审批',
				viewApproval: {
					quotationInfo: null,
					leadInfo: null,
					process: []
				},
				currentApproval: null,
				approvalForm: {
					status: 'approved',
					comment: '',
					ccUsers: []
				},
				approvalRules: {
					status: [{
						required: true,
						message: '请选择审批结果',
						trigger: 'change'
					}],
					examineOpinion: [{
						required: true,
						message: '请输入审批意见',
						trigger: 'blur'
					}],
					ccUsers: [{
						required: false,
						message: '请选择抄送人',
						trigger: 'change'
					}]
				},
				activeTab: 'basic',
				resizeObserver: null,
				rafId: null,
				store: null,
				userOptions: [],
				userSearchLoading: false
			}
		},
		computed: {
			isLastApprover() {
				if (!this.currentApproval || !this.viewApproval.process) return false
				const process = this.viewApproval.process
				const currentIndex = process.findIndex(item => item.userId === this.currentApproval.userId)
				return currentIndex === process.length - 1
			}
		},
		watch: {
			dateRange(val) {
				if (val) {
					this.filterForm.startDate = val[0]
					this.filterForm.endDate = val[1]
				} else {
					this.filterForm.startDate = ''
					this.filterForm.endDate = ''
				}
			},
			viewDialogVisible(val) {
				if (!val) {
					this.viewApproval = {
						quotationInfo: null,
						leadInfo: null,
						process: []
					}
					this.activeTab = 'basic'
				}
			},
			approvalDialogVisible(val) {
				if (!val) {
					this.currentApproval = null
					this.approvalForm = {
						status: 'approved',
						comment: '',
						ccUsers: []
					}
				}
			}
		},
		created() {
			this.store = useStore()
			this.fetchData()
		},
		mounted() {
			this.store.dispatch('fetchUserInfo')
			// 添加 ResizeObserver 处理
			const debouncedLayout = debounce(() => {
				if (this.rafId) {
					cancelAnimationFrame(this.rafId)
				}
				this.rafId = requestAnimationFrame(() => {
					if (this.$refs.approvalTable) {
						this.$refs.approvalTable.doLayout()
					}
				})
			}, 100)

			this.resizeObserver = new ResizeObserver(() => {
				debouncedLayout()
			})

			// 只在表格存在时观察
			if (this.$refs.approvalTable && this.$refs.approvalTable.$el) {
				this.resizeObserver.observe(this.$refs.approvalTable.$el)
			}
		},
		beforeUnmount() {
			// 清理 ResizeObserver 和 RAF
			if (this.rafId) {
				cancelAnimationFrame(this.rafId)
				this.rafId = null
			}
			if (this.resizeObserver) {
				this.resizeObserver.disconnect()
				this.resizeObserver = null
			}
		},
		methods: {
			async fetchData() {
				try {
					const params = {
						current: this.currentPage,
						size: this.pageSize,
						...this.filterForm
					}
					const res = await getExamineInfo(params)
					this.approvalList = res.data.records
					this.total = res.data.total
				} catch (error) {
					console.error('获取审批列表失败:', error)
				}
			},
			async handleView(row) {
				this.viewDialogVisible = true
				try {
					const [quotationRes, flowRes] = await Promise.all([
						getOfferDetail({
							id: row.resourseId
						}),
						getExamineFlowDetail({
							id: row.id
						})
					])

					// 格式化时间字段
					const formatQuotationInfo = (info) => {
						if (!info) return null
						return {
							...info,
							createTime: this.formatDateTime(info.createTime),
							updateTime: this.formatDateTime(info.updateTime),
							offerTime: this.formatDateTime(info.offerTime),
							businessProducts: (info.businessProducts || []).map(product => ({
								...product,
								createTime: this.formatDateTime(product.createTime)
							}))
						}
					}

					const formatLeadInfo = (info) => {
						if (!info) return null
						return {
							...info,
							createTime: this.formatDateTime(info.createTime),
							updateTime: this.formatDateTime(info.updateTime),
							expectedTime: this.formatDateTime(info.expectedTime)
						}
					}

					const formatProcess = (process) => {
						return (process || []).map(item => ({
							...item,
							time: this.formatDateTime(item.time),
							updateTime: this.formatDateTime(item.updateTime)
						}))
					}

					this.viewApproval = {
						...row,
						createTime: this.formatDateTime(row.createTime),
						updateTime: this.formatDateTime(row.updateTime),
						quotationInfo: formatQuotationInfo(quotationRes.data),
						process: formatProcess(flowRes.data)
					}

					// 如果有线索ID，获取线索详情
					if (quotationRes.data && quotationRes.data.leadId) {
						try {
							const leadRes = await getLeadDetail({
								id: quotationRes.data.leadId
							})
							this.viewApproval.leadInfo = formatLeadInfo(leadRes.data)
						} catch (error) {
							console.error('获取线索详情失败:', error)
							this.$message.error('获取线索详情失败')
						}
					}
				} catch (error) {
					console.error('获取审批详情失败:', error)
					this.$message.error('获取审批详情失败')
				}
			},
			async handleApprove(row) {
				console.log(row)
				try {
					const res = await getExamineFlowDetail({
						id: row.id
					})
					console.log(res)
					this.viewApproval.process = res.data
					res.data.forEach(item => {
						if (item.userId === this.$store.state.user.id) {
							this.currentApproval = item
							this.approvalForm = {
								...item,
								ccUsers: []
							}
							this.approvalDialogVisible = true
						}
					})
				} catch (error) {
					console.error('获取审批流程失败:', error)
					this.$message.error('获取审批流程失败')
				}
			},
			async handleWithdraw(row) {
				try {
					await this.$confirm('确认撤回该审批吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					await withdrawApproval(row.id)
					this.$message.success('撤回成功')
					this.fetchData()
				} catch (error) {
					if (error !== 'cancel') {
						console.error('撤回审批失败:', error)
					}
				}
			},
			async submitApproval() {
				try {
					await this.$refs.approvalForm.validate()
					const submitData = {
						...this.approvalForm,
						id: this.currentApproval.id,
						ccUsers: this.isLastApprover ? this.approvalForm.ccUsers : []
					}
					await approveApproval(submitData)
					this.$message.success('审批成功')
					this.approvalDialogVisible = false
					this.fetchData()
				} catch (error) {
					console.error('提交审批失败:', error)
				}
			},
			formatDateTime(date, format = 'YYYY-MM-DD HH:mm:ss') {
				if (!date) return '--'
				return dayjs(date).format(format)
			},
			formatDate(date) {
				return this.formatDateTime(date, 'YYYY-MM-DD')
			},
			formatTime(date) {
				return this.formatDateTime(date, 'HH:mm:ss')
			},
			formatAmount(amount) {
				if (!amount && amount !== 0) return '--'
				return amount.toLocaleString('zh-CN', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				})
			},
			getTypeText(type) {
				const typeMap = {
					1: '报价审批',
					// leave: '请假申请',
					// expense: '报销申请',
					// business_trip: '出差申请',
					// purchase: '采购申请'
				}
				return typeMap[type] || type
			},
			getStatusType1(status) {
				const statusMap = {
					'-1': 'warning',
					0: 'primary',
					2: 'danger',
					1: 'success',
					4: 'info'
				}
				return statusMap[status] || 'info'
			},
			getStatusText1(status) {
				const statusMap = {
					'-1': '未进行',
					0: '审批中',
					2: '已拒绝',
					1: '已通过',
					4: '已撤销'
				}
				return statusMap[status] || status
			},
			getStatusType(status) {
				const statusMap = {
					1: 'warning',
					3: 'success',
					2: 'danger',
					4: 'info'
					// withdrawn: 'info'
				}
				return statusMap[status] || 'info'
			},
			getStatusText(status) {
				const statusMap = {
					1: '审批中',
					3: '已通过',
					2: '已拒绝',
					4: '已撤销'
					// withdrawn: '已撤回'
				}
				return statusMap[status] || status
			},
			getTimelineItemType(status) {
				const typeMap = {
					'-1': 'warning',
					0: 'primary',
					2: 'danger',
					1: 'success'
				}
				return typeMap[status] || 'info'
			},
			isApprover(row) {
				console.log(row.currentApprover, this.$store.state.user);

				// 判断当前用户是否为审批人
				return row.currentApprover === this.$store.state.user.username
			},
			isApplicant(row) {
				// 判断当前用户是否为申请人
				return row.username === this.$store.state.user.username
			},
			handleSearch() {
				this.currentPage = 1
				this.fetchData()
			},
			resetForm() {
				this.filterForm = {
					type: '',
					status: '',
					startDate: '',
					endDate: ''
				}
				this.dateRange = []
				this.handleSearch()
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.fetchData()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.fetchData()
			},
			getQuotationStatusType(status) {
				const statusMap = {
					0: 'primary',
					1: 'success',
					2: 'danger',
					4: 'info'
				}
				return statusMap[status] || 'info'
			},
			getQuotationStatusText(status) {
				const statusMap = {
					0: '审核中',
					1: '已审核',
					2: '已拒绝',
					4: '已撤销'
				}
				return statusMap[status] || status
			},
			canApprove(row) {
				// 判断是否可以审批
				return (
					row.status === 1 && // 待审批状态
					this.filterForm.type === '其他' && // 我审批的类型
					row.currentApprover === this.$store.state.user.username // 当前用户是审批人
				)
			},
			canWithdraw(row) {
				// 判断是否可以撤回
				return (
					row.status === 1 && // 待审批状态
					this.filterForm.type === 'my' && // 我提交的类型
					row.username === this.$store.state.user.username // 当前用户是申请人
				)
			},
			async searchUsers(query) {
				if (query) {
					this.userSearchLoading = true
					try {
						// 这里需要调用后端搜索用户的API
						const res = await getUserList({
							name: query
						})
						this.userOptions = res.data
					} catch (error) {
						console.error('搜索用户失败:', error)
						this.$message.error('搜索用户失败')
					} finally {
						this.userSearchLoading = false
					}
				} else {
					this.userOptions = []
				}
			},
			getLeadStatusType(status) {
				const statusMap = {
					0: 'info',
					1: 'warning',
					2: 'success',
					3: 'danger'
				}
				return statusMap[status] || 'info'
			},
			getLeadStatusText(status) {
				const statusMap = {
					0: '未跟进',
					1: '跟进中',
					2: '已成交',
					3: '已失效'
				}
				return statusMap[status] || status
			}
		}
	}
</script>

<style scoped>
	.filter-form {
		display: flex;
		flex-wrap: wrap;
	}


	.pagination-container {
		margin-top: 20px;
		text-align: right;
	}

	.approval-content {
		padding: 10px;
		background-color: #f5f7fa;
		border-radius: 4px;
	}

	.approval-process {
		margin-top: 20px;
		padding-top: 20px;
		border-top: 1px solid #EBEEF5;
	}

	.approval-process h3 {
		margin-bottom: 20px;
		font-size: 16px;
		color: #303133;
	}

	.approval-comment {
		margin-top: 5px;
		color: #606266;
		font-size: 13px;
	}

	.el-dialog {
		display: flex;
		flex-direction: column;
		margin: 0 !important;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		max-height: calc(100vh - 30px);
		max-width: calc(100vw - 30px);
	}

	.el-dialog__body {
		flex: 1;
		overflow: auto;
		padding: 20px;
	}

	.el-timeline {
		margin: 0;
		padding: 0;
	}

	.timeline-item-content {
		padding: 8px 0;
	}

	.timeline-item-content h4 {
		margin: 0 0 8px 0;
		color: #303133;
	}

	.timeline-item-content p {
		margin: 4px 0;
		color: #606266;
		line-height: 1.5;
	}
</style>